import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconComponent } from '../icon/icon.component';
import { RadioButtonModule } from 'primeng/radiobutton';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'ly-instagram-post-types',
  standalone: true,
  imports: [CommonModule, IconComponent, RadioButtonModule, FormsModule],
  templateUrl: './instagram-post-types.component.html',
  styleUrl: './instagram-post-types.component.scss',
})
export class InstagramPostTypesComponent {
  @Input() type!: 'post' | 'story' | 'reel';
  @Input() disabled = false;
  @Output() typeChange = new EventEmitter<'post' | 'story' | 'reel'>();

  changePostType(): void {
    if (this.disabled) return;
    this.typeChange.emit(this.type);
  }
}
